import { useEffect, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import SiteNav from "./SiteNav";
import SiteFooter from "./SiteFooter";

type Props = {
  children: ReactNode;
  navVariant?: "transparent" | "solid";
};

export default function SiteLayout({ children, navVariant = "transparent" }: Props) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-cream-50 font-sans text-ink-800">
      <SiteNav variant={navVariant} />
      <main className="flex-1">{children}</main>
      <SiteFooter />
    </div>
  );
}